import { render } from "./QuestionFive.vue?vue&type=template&id=334dd08b&scoped=true"
import script from "./QuestionFive.vue?vue&type=script&lang=js"
export * from "./QuestionFive.vue?vue&type=script&lang=js"

import "./QuestionFive.vue?vue&type=style&index=0&id=334dd08b&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-334dd08b"]])

export default __exports__